export default "__VITE_ASSET__Do$34jf3__"